import React, { useRef } from "react";
import ReactPlayer from "react-player";

import myVideo from "../videos/Steadiset.mp4";

import '../css/VideoPlayer.css';

const FactoryAutomationVideoPlayer_4 = () => {
  const videoRef = useRef(null);

  return (
    <div className="video-container">
      <ReactPlayer
      volume={0.0}
        playing={false}
        className="video-player"
        url={myVideo}
        controls={true}
      />
    </div>
  );
};

export default FactoryAutomationVideoPlayer_4;
